import scope from "@/constants/Scope";

const settings = {
    categoryName: "settings",
    scope: scope,
  } as const;

  export default settings;